var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',{staticClass:"header"},[_c('div',[_c('img',{staticClass:"header_img",attrs:{"src":_vm.logoUrl,"alt":"魅TV"}})])])}
var staticRenderFns = []

export { render, staticRenderFns }